import { Parking, Place } from '../models';
import { HttpService } from './http';
export class ParkingService {
  static async getParking(id, apiVersion = 'v1') {
    try {
      const data = await HttpService.get(apiVersion, `/parkings/${id}`, []);
      return parseParking(data, apiVersion);
    } catch (err) {
      console.error('[ParkingService][getParking]', err);
      throw err;
    }
  }
  static async getParkingLots({
    cyclabilityZoneId,
    zoom,
    bounds,
    forceUpdate,
    apiVersion = 'v1',
    query
  }) {
    if (zoom < 16 && !forceUpdate) return [];
    try {
      const params = [];
      if (cyclabilityZoneId) params.push({
        key: 'cyclability_zone_id',
        value: cyclabilityZoneId
      });
      if (bounds) params.push({
        key: 'north',
        value: bounds.north
      }, {
        key: 'east',
        value: bounds.east
      }, {
        key: 'south',
        value: bounds.south
      }, {
        key: 'west',
        value: bounds.west
      });
      if (query) params.push({
        key: 'query',
        value: query
      });
      const data = await HttpService.get(apiVersion, '/parkings', params);
      return data.map(parking => parseParking(parking, apiVersion));
    } catch (err) {
      console.error('[ParkingService][getParkingLots]', err);
      throw err;
    }
  }
}
const rackTypes = {
  ANCHORS: 'anchors',
  BUILDING: 'building',
  LOCKERS: 'lockers',
  OTHER: 'other',
  SHED: 'shed',
  STANDS: 'stands',
  TWO_TIER: 'twoTier',
  'two-tier': 'twoTier',
  UNKNOWN: 'unknown',
  WALL_LOOPS: 'wallLoops'
};
const accessTypes = {
  CUSTOMERS: 'customers',
  PRIVATE: 'private',
  PUBLIC: 'public'
};

// The backend network is free text: only the networks we have a logo for are mapped.
const networks = {
  BiciBox: 'bicibox',
  Veligo: 'veligo',
  Velocity: 'velocity',
  Véligo: 'veligo',
  Vélocéo: 'veloceo'
};
function parseParking({
  id,
  code,
  location,
  capacity,
  type,
  access_type,
  is_payant,
  is_sheltered,
  is_station,
  is_supervised,
  is_locked,
  subscription,
  network,
  operator,
  website,
  start_date,
  osm_geom,
  osm_id
}, apiVersion) {
  const osmId = apiVersion === 'v2' ? code : osm_id?.toString();
  return new Parking(id, code, new Place(undefined, location), capacity, rackTypes[type], accessTypes[access_type], !is_payant, is_sheltered, is_station, is_supervised, is_locked, subscription, network && networks[network] || null, website, start_date || null, osmId || null, parseOsmGeom(osm_geom), operator?.trim() || null, network?.trim() || null);
}
function parseOsmGeom(osmGeom) {
  const normalizedOsmGeom = osmGeom?.toLowerCase();
  if (normalizedOsmGeom === 'node' || normalizedOsmGeom === 'way') return normalizedOsmGeom;
  return null;
}